<!-- 弹框 -->
<template>
  <div :visible="visible" ref="tipsBox" @update:visible="updateDialog" class="tipsBox">
    <div ref="showPopover" class="tipsClass animated">
      <div>{{tipsContent}}</div>
    </div>
  </div>
</template>
<script>
    export default {
        name: "BombTips",
      props: {
        visible: Boolean,
        tipsContent: String
      },
      methods: {
        get() {
          if (this.visible) {
            this.$refs.tipsBox.children[0].className = "tipsClass";
            this.updateDialog(false);
          } else {
            this.$refs.tipsBox.children[0].className = "tipsClass animated";
          }
        },
        updateDialog(val) {
          this.$emit("update:visible", val);
        }
      },
      mounted() {
        this.timer = setInterval(this.get, 1000);
      },
      beforeDestroy() {
        clearInterval(this.timer);
      }
    };
</script>

<style lang="less" scoped>
  .tipsClass {
    top: 30%;
    left: 50%;
    width: 20%;
    height: 40px;
    line-height: 40px;
    position: absolute;
    padding: 0 15px;
    background: black;
    font-size: 12px;
    margin: 0px auto;
    text-align: center;
    color: white;
    opacity: 1;
    transform: translate(-50%, -50%);
    border-radius: 3px;
    z-index: 99999;
  }
  .animated {
    opacity: 0;
    padding: 10px ;
    filter: Alpha(opacity=0);
    transition: all 3s;
  }
</style>



// WEBPACK FOOTER //
// src/views/Contacts/BombTips.vue